import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { newArticleForm } from './useArticleSchema';
import { create } from 'adapters/articleAdacter';
import { useMutation, useQuery } from '@tanstack/react-query';
import { articleService } from 'services';
import useErrors from 'hooks/useErrors';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { getItemFromStore, setItemToStore } from 'helpers/utils';

const useNewArticle = ({ query } = { query: false }) => {
 const { code } = useParams();
 const [resetValues, setResetValues] = useState(
  code ? getItemFromStore('article', newArticleForm.defaultValues) : newArticleForm.defaultValues
 );
 const { setError } = useErrors();
 const [articles, setArticles] = useState(getItemFromStore('articles', []));
 const [loading, setLoading] = useState(false);
 const { getArticle, getArticles, createArticle, updateArticle } = articleService.useApiArticles();
 const { mutate: newArticle } = useMutation(code ? updateArticle : createArticle);

 const { isLoading } = useQuery(['articles'], getArticles, {
  onSuccess: data => {
   setArticles(data);
   setItemToStore('articles', data);
   console.log(data, 'termino la carga');
  },
  onSettled: () => setLoading(false),
  onError: err => setError(err),
  enabled: query
 });

 useQuery(['article'], () => getArticle(code), {
  onSuccess: data => setResetValues(data),
  onSettled: () => setLoading(false),
  onError: err => setError(err),
  enabled: false // !!code
 });

 const methods = useForm({
  resolver: yupResolver(newArticleForm.schema),
  defaultValues: resetValues
 });

 const { handleSubmit, reset, watch } = methods;

 const onError = e => {
  console.log(e, 'este es el error que surje');
 };

 const onSubmit = async data => {
  setLoading(true);
  if (code) data.code = code;
  const adacterData = await create(data);
  newArticle(
   { code: code ?? null, data: adacterData },
   {
    onSuccess: newArticle => {
     const resetData = code ? newArticle : newArticleForm.defaultValues;
     reset({ ...resetData });
     setItemToStore('article', resetData);
    },
    onError: err => setError(err),
    onSettled: (data, error) => {
     setLoading(false);
     toast[error ? 'error' : 'success'](error ? 'Error al procesar la solicitud' : 'Articleo creado correctamente');
    }
   }
  );
 };

 useEffect(() => {
  const subscription = watch((value, { name }) => {
   if (name === undefined) return;
   console.log(value, 'el formulario cambio', name);
  });
  return () => subscription.unsubscribe();
 }, [watch]);

 return { articles, isLoading, loading, methods, handleSubmit, reset, watch, onSubmit, onError };
};

export { useNewArticle };
